<template>
  <section class="notifications">
      <b-nav-item-dropdown ref="notificationDropdown" right no-caret toggle-class="notifications--dropdown-as-btn">
        <template slot="button-content" class="image-dropdown">
            <button class="notifications--btn">
                <div class="notifications--count" v-if="notifications.actives >= 1">
                  {{ notifications.actives >= majorNumberAllowed ? `${majorNumberAllowed-1}+` : notifications.actives }}
                </div>
                <i class="notifications--bell icon-bell"></i>
            </button>
        </template>
        <section class="notifications--dropdown">
            <header class="notifications--header">
              <div class="notifications--header-title">{{$t('Notificaciones')}}</div>
              <button
                class="notifications--read-all"
                :class="{'disabled': notifications.actives == 0 || loading }"
                v-on:click="markAllAsReaded"
              >
                <i class="fa fa-check mr-1"></i>
                <span>{{notifications.actives == 0 ? $t('Todas leídas') : $t('Marcar todas como leídas')}}</span>
              </button>
            </header>
            <section class="notifications--list" v-if="notifications.items.length >= 1">
                <NotificationsTimeCard
                  v-for="notification of notifications.items" :key="notification.id"
                  :notification="notification"
                  @markRead="markAsReaded"
                  @hideNotify="hideNotifications"
                />
                <infinite-loading ref="InfiniteLoading" force-use-infinite-wrapper=".notifications-body" @infinite="infiniteHandler" :distance="0">
                  <div slot="no-more"></div>
                </infinite-loading>
            </section>
        </section>
        <section class="notifications--footer">
          <div v-if="loading">
            <i class="fa fa-spinner fa-spin fa-fw mr-1"></i>
            {{ $t('Cargando...') }}
          </div>
          <span v-if="!loading && notifications.actives == 0">{{ $t('No hay nuevas notificaciones') }}</span>
          <span v-if="!loading && notifications.actives > 0">
            {{notifications.actives}} {{notifications.actives === 1 ? $t('Nueva notificación') : $t('Nuevas notificaciones')}}
          </span>
        </section>
      </b-nav-item-dropdown>
  </section>
</template>

<script>
  import { mapGetters } from 'vuex'
  import NotificationsTimeCard from './Notification__timeCard.vue'
  import {NotificationServiceMixim} from '@/mixims/NotificationServiceMixim.js'

  import InfiniteLoading from 'vue-infinite-loading'

  export default {
    name: 'HeaderNotifications',
    components: {
      NotificationsTimeCard,
      InfiniteLoading
    },
    mixins: [NotificationServiceMixim],
    data () {
      return {
        loading: false,
        majorNumberAllowed: 10,
        params: {from: 0, size: 10}
      }
    },
    computed: {
      ...mapGetters(['notifications'])
    },
    mounted () {
      this.getAllNotifications()
      this.getUnreadNotifications()
    },
    methods: {
      getAllNotifications () {
        this.loading = true
        this.getNotifications(this.params).then((response) => {
          if (response.body !== null) {
            this.$store.dispatch('setNotifications', response.body)
          }
          this.loading = false
        }, (error) => {
          this.loading = false
        })
      },
      getUnreadNotifications () {
        this.loading = true
        this.getNotifications(this.params, true).then((response) => {
          if (response.body !== null) {
            let totalCount = parseInt(response.headers.get('X-Total-Count'))
            this.$store.dispatch('setNewNotifications', totalCount)
          }
          this.loading = false
        }, (error) => {
          this.loading = false
        })
      },
      markAllAsReaded () {
        if (this.notifications.actives === 0) return
        this.loading = true
        this.markNotificationsAllReaded().then((response) => {
          this.$store.dispatch('setNotifications', this.notifications.items.map(item => ({ ...item, read: true }) ))
          this.getUnreadNotifications()
          this.loading = false
        }, (error) => {
          this.loading = false
        })
      },
      markAsReaded (id) {
        this.loading = true
        this.markNotificationRead(id).then((response) => {
          this.loading = false
          this.getUnreadNotifications()
          this.$store.dispatch('markAsReaded', id)
        }, (error) => {
          this.loading = false
        })
      },
      infiniteHandler ($state) {
        this.loading = true
        this.params.from += 1
        this.getNotifications(this.params).then((response) => {
          if (response.body && response.body.length && response.body !== null) {
            this.$store.dispatch('pushNotifications', response.body).then(success => {
              $state.loaded()
            })
          } else {
            $state.complete()
          }
          this.loading = false
        }, (error) => {
          this.loading = false
        })
      },
      hideNotifications () {
        this.$refs.notificationDropdown.hide()
      }
    }
  }
</script>

<style lang="scss">
@import './_notifiVars.scss';
@import 'scss/_bootstrap-variables.scss';

.navbar-nav {
  .dropdown-menu {
    border-radius: 10px;
    border: solid 1px $gray-200;
    overflow: hidden;
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.25);
  }
}

.notifications {
  &--btn {
    position: relative;
    width: 40px;
    height: 40px;
    background: transparent;
    border-radius: 100%;
    border: solid 1px $gray-200;
    background: $gray-100;
    color: $header-notification-color;
    font-size: 18px;

    &:hover, &:focus {
      border-color: lighten($header-notification-color, 25%);
      background: lighten($header-notification-color, 30%);
      color: white;
      outline: none;
    }
  }

  &--count {
    position: absolute;
    top: 0;
    left: 0;
    width: 19px;
    background-color: tomato;
    height: 19px;
    line-height: 19px;
    text-align: center;
    border-radius: 100%;
    font-weight: bold;
    font-size: 10px;
    color: white;
  }

  &--dropdown {
    width: 350px;
    display: flex;
    flex-direction: column;
    background: white;
  }

  &--header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 10px;
    background: $gray-100;
    border-bottom: solid 1px $gray-200;

    &-title {
      font-weight: bold;
      font-size: 16px;
      color: #333;
    }
  }

  &--read-all {
    margin: 0 0 0 auto !important;
    padding: 0;
    font-size: 12px;
    color: #3553af;
    border: none;
    background-color: transparent;
    cursor: pointer;

    &:hover, &:focus {
      color: #6a88e2;
      outline: none;
    }

    &.disabled {
      pointer-events: none;
      color: #aaa;
    }
  }

  .notifications--list {
    max-height: 320px;
    overflow-y: scroll;
    scroll-behavior: smooth;

    &::-webkit-scrollbar {
      width: 5px;
    }
    &::-webkit-scrollbar-track {
        background: $background-dropdown-notifications;
    }
    &::-webkit-scrollbar-thumb {
        background: darken($header-notification-color, 0);
    }
    &::-webkit-scrollbar-thumb:hover {
        background: darken($header-notification-color, 5);
    }
  }

  &--footer {
    padding: 10px;
    background: $gray-100;
    text-align: center;
    color: $header-notification-color;
  }
}

</style>
